module.exports = __webpack_public_path__ + "static/campus-89a087e76280b7da0106952b65312117.png";